import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
import * as i2 from "../../services/globals.service";
import * as i3 from "@angular/common/http";
export class TransationReceiptService extends BaseProvider {
    constructor(translate, globals, http) {
        super();
        this.translate = translate;
        this.globals = globals;
        this.http = http;
        this.workingInvoice = [];
        this.costs = { costs: [] };
        this.feeAmount = [];
        this.additionalInfo = [];
        this.initialPaymentDetails = [];
        this.baseUrl = 'userProcessInvoice';
        this.translate
            .get(['payment.convenienceFee'])
            .subscribe(translations => {
            this.feeAmount = [
                {
                    id: 1,
                    name: 'costs.convenienceFee',
                    cost: 0,
                }
            ];
        });
    }
    getInvoiceById(id) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/' + id;
            this.http
                .get(this.url)
                .subscribe((data) => {
                if (data.Data.length > 0) {
                    this.workingInvoice = data.Data[0];
                    try {
                        this.additionalInfo = JSON.parse(this.workingInvoice.AdditionalInfo);
                    }
                    catch (_a) {
                        this.additionalInfo = this.workingInvoice.AdditionalInfo;
                    }
                    this.manageCosts();
                    resolve(data.Data);
                }
                else {
                    resolve(null);
                }
            }, err => { reject(err); });
        });
    }
    getInitialPaymentDetails(invoiceId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + `/processType/InitialPayment/${invoiceId}`;
            this.http
                .get(this.url)
                .subscribe((data) => {
                this.initialPaymentDetails = data.Data;
                resolve(this.initialPaymentDetails);
            }, err => { reject(err); });
        });
    }
    manageCosts() {
        if (this.workingInvoice.CostJson) {
            this.costs = JSON.parse(this.workingInvoice.CostJson);
            this.feeAmount[0].cost = this.workingInvoice.FeeAmount;
            if (this.costs.costs) {
                this.costs.costs[this.costs.costs.length] = this.feeAmount[0];
                for (let i = 0; i < this.costs.costs.length; i++) {
                    this.workingInvoice.Costs.push(this.costs.costs[i]);
                    this.workingInvoice.Costs[i].Qty = 1;
                }
            }
        }
        // else{
        // 	this.workingInvoice.Costs.push({
        // 		"CostDescription": "costs.convenienceFee",
        // 		"Amount": this.workingInvoice.FeeAmount,
        // 		"Qty": 1
        // 	});
        // }
    }
}
TransationReceiptService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TransationReceiptService_Factory() { return new TransationReceiptService(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(i2.GlobalsService), i0.ɵɵinject(i3.HttpClient)); }, token: TransationReceiptService, providedIn: "root" });
